import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-property-status',
  templateUrl: './property-status.component.html',
  styleUrls: ['./property-status.component.scss']
})
export class PropertyStatusComponent implements OnInit {
  public _inPreOrderDate: string;
  public _inLiveDate: string;
  public _isPropertyLive: boolean = false;
  public _class: string = '';

  @Input()
  set preOrderDate(value: string) {
    this._inPreOrderDate = value;
  }

  @Input()
  set liveDate(value: string) {
    this._inLiveDate = value;
  }

  @Input()
  set isLive(value: boolean) {
    this._isPropertyLive = value;
  }

  @Input()
  set customClass(value: string) {
    this._class = value;
  }

  constructor() {}

  ngOnInit() {}
}
